module.exports = __webpack_public_path__ + "static/img/bg.e2e9a17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/team/bg.png
// module id = 269
// module chunks = 6